<!--  -->
<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>{{Label}}</h3>
        </div>
    </div>
</header>
<main #scroll>
    <div class="city-search">
        <div class="filtering">
        </div>
    </div>
    <div class="add-district">
        <h5 class="mb-3">{{Label}}</h5>
        <div class="loginWraper" *ngIf="Label != 'વિડિયો'">
            <form [formGroup]="uploadForm">
                <div class="row">
                    <div class="col-md-12">
                        <div class="district-form-group form-group">
                            <input type="file" class="form-control" [placeholder]="Label" formControlName="src" required
                                [accept]="formate" (change)="getImage($event)" />
                            <div *ngIf="submitted && f.src.errors" class="error-message mt-5">
                                <small *ngIf="f.src.errors?.required" class="text-danger">ફાઇલ જરૂરી છે</small>
                            </div>
                            <button type="submit" (click)="AddMemoryPhotoOrVideo()"><i class="ti ti-plus"></i></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="loginWraper" *ngIf="Label === 'વિડિયો'">
            <form [formGroup]="uploadForm">
                <div class="row">
                    <div class="col-md-12">
                        <div class="district-form-group form-group">
                            <input type="text" class="form-control" [placeholder]="Label" formControlName="src" required
                                [accept]="formate" (change)="getImage($event)" />
                            <div *ngIf="submitted && f.src.errors" class="error-message mt-5">
                                <small *ngIf="f.src.errors?.required" class="text-danger">ફાઇલ જરૂરી છે</small>
                            </div>
                            <button type="submit" (click)="AddMemoryPhotoOrVideo()"><i class="ti ti-plus"></i></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <hr>
    <div class="city-list district_list text-center">
        <lightgallery [settings]="settings" [onInit]="onInit">
        </lightgallery>
        <button type="submit" class="btn-common" (click)="openGallery()">{{Label}} ખોલો</button>
    </div>
</main>